// extracted by mini-css-extract-plugin
module.exports = {"menuSubTitle":"DigitizationSidebar_menuSubTitle__2u8CZ","dropDownTitle":"DigitizationSidebar_dropDownTitle__3q26p"};